import { SET_APP_LOADING } from '../../constants';

export const setAppLoadingState = (dispatch: any, payload: any) => {
  dispatch({
    payload,
    type: SET_APP_LOADING,
  });
};
